import { css } from '@mui/material/styles';
export const tooltipComponentOverrides = {
    MuiTooltip: {
        defaultProps: {
            arrow: true
        },
        styleOverrides: {
            tooltip: ({ theme }) => css `
                background-color: ${theme.tokens.FuelColorGray900};
                box-shadow: ${theme.tokens.FuelShadowXl};
                font-size: ${theme.tokens.FuelFontSizeXs};
                font-weight: ${theme.tokens.FuelFontWeightRegular};
            `,
            arrow: ({ theme }) => css `
                color: ${theme.tokens.FuelColorGray900};
            `
        }
    }
};
